import { useQuery } from "@tanstack/react-query";
import http from "../../utils/http-common";
import type { ServiceProcedure } from "../../interfaces";

export const useServiceProcedureByAgent = (agentUUID: string) => {
  return useQuery<ServiceProcedure[]>({
    queryKey: ["service_procedures", agentUUID],
    queryFn: async () => {
      const { data } = await http.get(`/services/${agentUUID}`);
      return data;
    },
  });
};
